import { FC, Fragment } from 'react';
import { FormattedMessage, IntlProvider, IntlShape, useIntl } from 'react-intl';
import { ConfigProvider } from 'antd';
import { observer } from 'mobx-react';
import antdEn from 'antd/lib/locale/en_US';
import antdZh from 'antd/lib/locale/zh_CN';
import en from '@/assets/locales/en';
import zh from '@/assets/locales/zh';
import { useLocale } from '@/store';

const localesMapper = {
  en: {
    custom_locale: en,
    antd_locale: antdEn,
  },
  zh: {
    custom_locale: zh,
    antd_locale: antdZh,
  },
};

let intl: IntlShape;

const IntlCapture: FC<{ locale: string }> = (props) => {
  intl = useIntl();
  return <Fragment>{props.children}</Fragment>;
};

// 方便使用
export const $t = (id: string, values?: Record<string, string>) => {
  return intl.formatMessage({ id }, values);
};

export const $fm = (
  id: string,
  values?: Record<string, string | number>,
): React.ReactNode => {
  return <FormattedMessage id={id} values={values}></FormattedMessage>;
};

const IntlWrapper: FC = observer(({ children }) => {
  const [curLocale] = useLocale();

  const { custom_locale, antd_locale } = localesMapper[curLocale];

  return (
    <IntlProvider locale={curLocale} messages={custom_locale}>
      <IntlCapture locale={curLocale}>
        <ConfigProvider locale={antd_locale}>{children}</ConfigProvider>
      </IntlCapture>
    </IntlProvider>
  );
});

export default IntlWrapper;
